import dayjs from 'dayjs';

const calculateAge = (birthDateStr, asOfDateStr) => {
  const birthDate = dayjs(birthDateStr || '');
  if (birthDate.isValid()) {
    let asOfDate = asOfDateStr ? dayjs(asOfDateStr) : dayjs();
    const today = dayjs();
    if (asOfDate.isBefore(today, 'day')) {
      asOfDate = today;
    }
    const birthYear = +birthDate.format('YYYY');
    const asOfYear = +asOfDate.format('YYYY');
    let travelerAge = asOfYear - birthYear;
    // Compare dayjs objects directly. Formatting to a non-ISO string and
    // re-parsing it is engine-dependent: Safari returns Invalid Date for
    // "MM-DD-YYYY", which silently skipped this correction.
    if (birthDate.isAfter(asOfDate.subtract(travelerAge, 'year'), 'day')) {
      travelerAge -= 1;
    }
    return travelerAge;
  }
  return null;
};

export default calculateAge;
